import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import Input from '../../global/Input';
import {
    useCreateParcelMutation,
    useCreateParcelPersonMapMutation, useGetGemarkungCodesQuery,
    useGetParcelUseTypesQuery,
    useGetRegisterUpdateTypesQuery,
    useGetValuationTypesQuery,
    useUpdateParcelMutation
} from '../../../redux/rtk/injectedParcelApi';
import {useCleanArray} from '../../hooks/useCleanArray';
import {showMessageOnError, showMessageOnSuccess} from '../../global/CustomToast';
import {combineFlstkennz, iterateOverKeys, splitFlstkennz} from '../../functions/Global';
import {addMappings, Mapping, MappingType, resetMappings} from '../../../redux/slices/MappingSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {PersonMapping} from '../person/PersonMapping';
import {LandRegisterMapping} from '../landRegister/LandRegisterMapping';
import {checkPermission, getMappingsForUpdate, saveMappings} from '../../../functions/functionLibrary';
import {useDeleteMappingMutation, useUpdateMappingMutation} from '../../../redux/rtk/injectedMappingApi';
import {
    useGetBundeslandQuery,
    useGetGemeindeQuery,
    useGetKreisQuery
} from '../../../redux/rtk/injectedIsoBundeslandApi';
import {Accordion, AccordionTab} from 'primereact/accordion';
import StatusLight from '../../global/StatusLight';
import {AddressForm} from '../AddressForm';
import MapOl from '../../geoData/map';
import LayersMapOl from '../../geoData/layer/LayersMapOl';
import BaseLayers from '../../geoData/layer/BaseLayers';
import PoiLayer from '../../geoData/layer/PoiLayer';
import {Button} from 'primereact/button';
import CommentHistory from '../../global/CommentHistory';
import geoSettings from '../../../config/geoSettings';
import {getMapCenter} from '../../../functions/functionsOpenlayer';
import {setBaseLayer, setBaseWorkspace, setWorkspace} from '../../../redux/slices/GeomonitoringSlice';
import SingleLayer from '../../geoData/layer/SingleLayer';
import EditDialogLayout from '../../global/EditDialogLayout';
import FormPrompt from '../../global/FormPrompt';
import {CommentForm} from '../CommentForm';
import {TabPanel, TabView} from 'primereact/tabview';
import {ParcelMapping} from './ParcelMapping';
import {BankForm} from '../BankForm';
import {PropertyValueForm} from '../PopertyValueForm';
import {moveComments, Parcel} from '../../functions/GlobalData';
import UnderConstruction from '../../../views/pages/UnderConstruction';
import moment from 'moment';
import CautionSign from '../../global/CautionSign';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDatabase, faList, faMapLocation, faProjectDiagram} from '@fortawesome/free-solid-svg-icons';
import {ProcessOverview} from '../process/ProcessOverview';
import {MeasureOverview} from '../../projectMasterData/measure/MeasureOverview';
import {UtilisationOverview} from '../../projectMasterData/utilisation/UtilisationOverview';
import {RadioButton} from 'primereact/radiobutton';
import {CorrespondenceMapping} from '../correspondence/CorrespondenceMapping';
import {ContractMapping} from '../contract/ContractMapping';
import {permissions} from '../../../config/permissions';
import {CustomConfirmDialog} from '../../global/CustomConfirmDialog';
import CustomDialog from '../../global/CustomDialog';

type Props = {
    projectId: string,
    data?: Parcel,
    setVisible: any,
    commonData: boolean,
    geoData: any,
    setIsDirty: (isDirty: boolean) => void
    onFinished: (success: any) => void,
    createNew?: boolean,
    duplicateNew?: boolean,
}
export const ParcelEditForm = (props: Props): JSX.Element => {
    const {t} = useTranslation(['common', 'stammdaten']);

    const mappings: Mapping[] = useAppSelector((state: any) => state.mappingData.mappings);
    const dispatch = useAppDispatch();

    const [updateMapping] = useUpdateMappingMutation();
    const [deleteMapping] = useDeleteMappingMutation();
    const [createParcel] = useCreateParcelMutation();
    const [updateParcel] = useUpdateParcelMutation();

    const [createParcelPersonMap] = useCreateParcelPersonMapMutation();

    const [data, setData] = useState<Parcel | undefined>(undefined);
    const [height, setHeight] = useState<number>(0);

    const [flstNenner, setFlstNenner] = useState<string>('');
    const [flstFlur, setFlstFlur] = useState<string>('');
    const [flstFolge, setFlstFolge] = useState<string>('');
    const [bundeslandIso, setBundeslandIso] = useState<string>('');
    const [mappingChanged, setMappingChanged] = useState<boolean>(false);

    const divRef: any = useRef(null);

    const [center, setCenter] = useState([0, 0]);
    const [zoom, setZoom] = useState(9);

    const [createNew, setCreateNew] = useState<boolean>(false);
    const [duplicateNew, setDuplicateNew] = useState<boolean>(false);

    const [disableFolge, setDisableFolge] = useState<boolean>(true);
    const [revisedKreisList, setRevisedKreisList] = useState<any[]>([]);
    const [revisedGemeindeList, setRevisedGemeindeList] = useState<any[]>([]);
    const [gemarkungCodes, setGemarkungCodes] = useState<any[]>([]);

    const [showNewProcess, setShowNewProcess] = useState<boolean>(false);
    const [newProcess, setNewProcess] = useState<boolean>(false);

    const bewertungTypesQuery = useGetValuationTypesQuery();
    const katasterFortschreibungTypesQuery = useGetRegisterUpdateTypesQuery();

    const countryIsoList = [{
        label: <div className={'flex'}><img className={'mr-1'}
                                            src={'/images/wappen/deutschland.svg'}
                                            width={25}
                                            height={25}/>
            <div className={'my-auto'}>Deutschland</div>
        </div>, value: 'Deutschland'
    }];

    const isCleaned = useCleanArray(data, {
        flurstueck_id: props.data ? props.data.flurstueck_id : undefined,
        project_id: props.projectId !== '' ? props.projectId : null
    }, props.commonData);

    const defaultValues: Parcel = {
        'active_id': data ? data.active_id : 0,
        'flurstueck_id': props.data ? props.data.flurstueck_id : '',
        'is_deleted': props.data ? props.data.is_deleted : false,
        'flstkennz': props.data ? props.data.flstkennz : '',
        'flstzaehler': props.data ? props.data.flstzaehler : '',
        'flstnenner': props.data ? props.data.flstnenner : '',
        'flur': props.data ? props.data.flur : '',
        'flstfolge': props.data ? props.data.flstfolge : '',
        'b_land_iso': props.data ? props.data.b_land_iso : '',
        'b_land_name': props.data ? props.data.b_land_name : '',
        'land_iso': props.data ? props.data.land_iso : '',
        'land_name': props.data ? props.data.land_name : '',
        'lfdnrbestandsvz': props.data ? props.data.lfdnrbestandsvz : 0,
        'zeitstempel': props.data ? props.data.zeitstempel : '',
        'kommentar': '',
        'kommentare': props.data && props.data.kommentare ? props.data.kommentare : [],
        'ersteller': props.data ? props.data.ersteller : '',
        'person': props.data ? props.data.person : [],
        'grundbuch': props.data ? props.data.grundbuch : [],
        'expandableElement': props.data ? props.data.expandableElement : undefined,
        'status_id': props.data ? props.data.status_id : 0,
        'kreis': props.data ? parseInt(props.data.kreis) : 0,
        'kreis_name': props.data ? props.data.kreis_name : '',
        'gemarkung': props.data ? props.data.gemarkung : '',
        'gemarkung_name': props.data ? props.data.gemarkung_name : '',
        'gemeinde': props.data ? props.data.gemeinde : '',
        'gemeinde_name': props.data ? props.data.gemeinde_name : '',
        'kataster_groesse': props.data ? props.data.kataster_groesse : 0,
        'liegenschaft_name': props.data ? props.data.liegenschaft_name : '',
        'liegenschaft_nutzung_types': props.data ? props.data.liegenschaft_nutzung_types : [],
        'abweichung_grundbuch': props.data ? props.data.abweichung_grundbuch : 0,
        'abweichung_plan': props.data ? props.data.abweichung_plan : 0,
        'abweichung_geo': props.data ? props.data.abweichung_geo : 0,
        'katasterfortschreibung_type': props.data ? props.data.katasterfortschreibung_type : 0,
        'gebucht': props.data && props.data.grundbuch && props.data.grundbuch.length > 0 ? true : false,
        'verpachtet': props.data ? props.data.verpachtet : false,
        'vertrag': props.data ? props.data.vertrag : false,
        'grundstueckswert': props.data ? props.data.grundstueckswert : [],
    };

    const {
        control,
        formState: {errors, isDirty},
        handleSubmit,
        setValue,
        getValues,
        reset,
        watch
    } = useForm({defaultValues});

    const verpachtet = watch('verpachtet');
    const kommentare = watch('kommentare');
    const liegenschaftName = watch('liegenschaft_name');
    const katasterfortschreibungType = watch('katasterfortschreibung_type');
    const grundstueckswert = watch('grundstueckswert');
    const bLand = watch('b_land_iso');
    const statusId = watch('status_id');

    const saveData = (data: any) => {
        // eslint-disable-next-line camelcase
        data = iterateOverKeys(data);
        //  console.log(data)
        setData(data);
    };

    const getMapCenterData = () => {
        const baseWorkspace = props.geoData.baselayer_workspace !== null ? props.geoData.baselayer_workspace : geoSettings.wmsWorkspace;
        const mapCenterData = getMapCenter({project: props.geoData});
        dispatch(setWorkspace(props.geoData.geoserver_workspace));
        dispatch(setBaseLayer(props.geoData.base_layer));
        dispatch(setBaseWorkspace(baseWorkspace));
        setZoom(mapCenterData.zoom);
        setCenter(mapCenterData.center);
    };

    const {data: bundeslandQuery = [], isLoading} = useGetBundeslandQuery();

    const {data: parcelUseTypesQuery = []} = useGetParcelUseTypesQuery();
    const {data: gemarkungCodesQuery = []} = useGetGemarkungCodesQuery();

    const {
        data: kreisQuery = [], isLoadingKreis,
        isSuccessKreis,
        isFetchingKreis,
    } = useGetKreisQuery();

    const {data: gemeindeQuery = []} = useGetGemeindeQuery();


    const getFormErrorMessage = (name: string) => {
        if (name.indexOf('.') >= 0) {
            const split = name.split('.');

            if (split.length === 3) {
                // @ts-ignore
                if (errors[split[0]] && errors[split[0]][split[1]] && errors[split[0]][split[1]][split[2]]) {
                    // @ts-ignore
                    const text = errors[split[0]][split[1]][split[2]].message;

                    showMessageOnError('', text);
                    return <small className="p-error custom">{text}</small>;
                }
            }
        } else {
            // @ts-ignore
            if (errors[name]) {
                // @ts-ignore
                const text = errors[name].message;

                showMessageOnError('', text);

                return <small className="p-error custom">{text}</small>;
            }
        }
        return undefined;
    };

    useEffect(() => {
        getMapCenterData();
        dispatch(resetMappings());
        console.log('parcelData', props.data);
    }, []);

    useEffect(() => {
        console.log(bLand);

        switch (bLand) {
            case '08':
            case '14':
                setDisableFolge(false);
                break;
            default:
                setDisableFolge(true);
                setValue('flstfolge', '__');
                break;
        }
    }, [bLand]);

    useEffect(() => {
        if (gemarkungCodesQuery) {
            setGemarkungCodes(gemarkungCodesQuery.map((item: any) => {
                return {value: item.id, label: `${item.id} (${item.name})`};
            }));
        }
    }, [gemarkungCodesQuery]);

    useEffect(() => {
        if (props.createNew) {
            setCreateNew(props.createNew);
        }
        if (props.duplicateNew) {
            setDuplicateNew(props.duplicateNew);
        }
    }, [props.createNew, props.duplicateNew]);

    useEffect(() => {
        if (createNew) {
            setCreateNew(false);
            setData(undefined);
            reset({
                'flurstueck_id': '',
                'gemarkung': '',
                'flstkennz': '',
                'flstzaehler': '',
                'flstnenner': '',
                'flur': '',
                'flstfolge': '',
                'b_land_iso': '',
                'b_land_name': '',
                'land_iso': '',
                'land_name': '',
                'lfdnrbestandsvz': 0,
                'zeitstempel': '',
                'kommentar': '',
                'kommentare': [],
                'ersteller': '',
                'person': [],
                'grundbuch': [],
                'expandableElement': undefined,
                'status_id': 0,
                'kreis': '',
                'gemeinde': '',
                'kataster_groesse': 0,
                'liegenschaft_name': '',
                'liegenschaft_nutzung_types': [],
                'abweichung_grundbuch': 0,
                'abweichung_plan': 0,
                'abweichung_geo': 0,
                'katasterfortschreibung_type': 0,
                'gebucht': false,
                'verpachtet': false,
                'grundstueckswert': []
            });
            showMessageOnSuccess('', t('globalData:toasts.createNewMessage'));
        }
    }, [createNew]);

    useEffect(() => {
        if (duplicateNew) {
            setDuplicateNew(false);
            reset(undefined, {keepValues: true});
            showMessageOnSuccess('', t('globalData:toasts.duplicateNewMessage'));
        }
    }, [duplicateNew]);

    useEffect(() => {
        props.setIsDirty(isDirty || mappingChanged);
    }, [isDirty, mappingChanged]);

    useEffect(() => {
        if (props.data) {
            setValue('b_land_name', props.data.b_land_name);
            setValue('gemarkung', props.data.gemarkung);
            setValue('flstzaehler', props.data.flstzaehler);
            setValue('flstnenner', props.data.flstnenner);
            setValue('flur', props.data.flur);
            setValue('flstfolge', props.data.flstfolge);
        }
    }, [props.data]);

    useEffect(() => {
        if (divRef.current) {
            setHeight(divRef.current.parentElement.clientHeight);
        }
    }, [divRef.current]);

    useEffect(() => {
        if (typeof data !== 'undefined') {
            if (props.data) {
                isCleaned.mappings = getMappingsForUpdate('flurstueck_id', data.flurstueck_id, mappings);

                updateParcel(isCleaned).then(async (result: any) => {
                    if (!result.error) {
                        if (result.data && result.data === 'vorgang') {
                            setShowNewProcess(true);
                        } else {
                            showMessageOnSuccess(t('globalData:global.parcelUpdated'), '');
                            console.log(isCleaned);
                            props.onFinished(isCleaned);
                            moveComments(getValues, setValue);
                            reset(undefined, {keepValues: true});
                            setMappingChanged(false);
                        }
                    }
                });
            } else {
                isCleaned.mappings = getMappingsForUpdate('flurstueck_id', '', mappings);

                createParcel({...isCleaned, flstkennz: data.flstkennz}).then(async (result: any) => {
                    if (!result.error) {
                        if (result === 'vorgang') {
                            setShowNewProcess(true);
                        } else {
                            showMessageOnSuccess(t('globalData:global.parcelCreated'), '');
                            props.onFinished(isCleaned);
                            moveComments(getValues, setValue);
                            reset(undefined, {keepValues: true});
                            setMappingChanged(false);
                        }
                    }
                });
            }
        }
    }, [data]);

    const onChangeFlstKennz = (e: any) => {
        const info: any = splitFlstkennz(e.target.value);
        if (info) {
            const filter = bundeslandQuery.filter((item: any) => {
                return item.id === info.b_land_iso;
            });

            if (filter.length > 0) {
                info.b_land_name = filter.map((item: any) => {
                    return item.name;
                })[0];
            }

            for (let i = 0; i < Object.keys(info).length; i++) {
                const key: any = Object.keys(info)[i];

                const path = undefined;

                setValue(key, info[key.toString()]);
            }
        }
    };

    const onChangeKreis = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        setValue('kreis', value);

    };
    const onChangeGemeinde = (e: any) => {

    };

    let timeout: any = undefined;

    const onChangeFlur = (e: any) => {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            onChangeFlurTimeout(e);
        }, 500);
    };

    const onChangeFlurTimeout = (e: any) => {
        const name = e.target.name;

        let value = e.target.value;

        if (!value) {
            value = '';
        }

        let temp_b_land_iso: string = name === 'b_land_iso' ? value : getValues('b_land_iso');
        let temp_gemarkung: string = name === 'gemarkung' ? value : getValues('gemarkung');
        const temp_flstzaehler: string = name === 'flstzaehler' ? value : getValues('flstzaehler');
        const temp_flstnenner: string = name === 'flstnenner' ? value : getValues('flstnenner');
        const temp_flur: string = name === 'flur' ? value : getValues('flur');
        const temp_flstfolge: string = name === 'flstfolge' ? value : getValues('flstfolge');

        if (name === 'b_land_iso') {
            if (temp_gemarkung && temp_gemarkung.length > 2) {
                temp_gemarkung = temp_b_land_iso + temp_gemarkung.substring(2, temp_gemarkung.length);
            } else {
                temp_gemarkung = temp_b_land_iso;
            }
            setValue('gemarkung', temp_gemarkung);
            setValue('b_land_iso', temp_b_land_iso);

        } else if (name === 'gemarkung') {

            if (temp_gemarkung && temp_gemarkung.length >= 2) {
                temp_b_land_iso = temp_gemarkung.substring(0, 2);
            } else {
                temp_b_land_iso = '0';
            }
            setValue('b_land_iso', temp_b_land_iso);
        }

        const result = combineFlstkennz({
            b_land_iso: temp_b_land_iso,
            b_land_name: '',
            gemarkung: temp_gemarkung || '',
            flstzaehler: temp_flstzaehler || '',
            flstnenner: temp_flstnenner || '',
            flur: temp_flur || '',
            flstfolge: temp_flstfolge || ''
        });

        setValue('flstkennz', result);
    };

    const getStatus = () => {
        return (
            <StatusLight id={'statuslight-parceleditform'} value={statusId} info={'Testinfo'} light={false}
                         horizontal={false} caution={false}/>);
    };

    // Accordion Headlines --->

    const getLiegenschaftInfoAccordionHeadline = () => {
        let right = '';

        if (liegenschaftName) {
            right = liegenschaftName;
        }

        return (<div className={'grid grid-nogutter'}>
            <div
                className={'col'}>{t('globalData:parcels.liegenschaftInfo')}</div>
            <div className={'col-auto text-right'}>{right}</div>
        </div>);
    };

    const getGrundstueckAccordionHeadline = () => {
        let right = '';

        if (grundstueckswert && grundstueckswert.length > 0) {

            let bodenrichtwert: number = 0;
            let verkehrswert: number = 0;

            for (let i = 0; i < grundstueckswert.length; i++) {
                const gsw = grundstueckswert[i];

                try {
                    bodenrichtwert += parseFloat(gsw.bodenrichtwert);
                    verkehrswert += parseFloat(gsw.verkehrswert);
                } catch (error) {
                }
            }

            right = t('globalData:parcels.bodenrichtwert') + ': ' + bodenrichtwert + ' / ' + t('globalData:parcels.verkehrswert') + ': ' + verkehrswert;
        }

        return (<div className={'grid grid-nogutter'}>
            <div
                className={'col'}>{t('globalData:parcels.grundstueckswerte')}</div>
            <div className={'col-auto text-right'}>{right}</div>
        </div>);
    };

    const getKatasterAccordionHeadline = () => {
        let right = '';

        if (katasterfortschreibungType) {
            const type = katasterFortschreibungTypesQuery.data.find((item: any) => {
                return item.id === katasterfortschreibungType;
            });

            if (type) {
                right = type.name;
            }
        }

        return (<div className={'grid grid-nogutter'}>
            <div
                className={'col'}>{t('globalData:parcels.katasterfortschreibung_type')}</div>
            <div className={'col-auto text-right'}>{right}</div>
        </div>);
    };


    const getCommentAccordionHeadline = () => {
        let right = '';

        if (kommentare && kommentare.length > 0) {
            right = t('lastEntry') + ': ' + moment(kommentare[0].zeitstempel).format(t('datetimeformat'));
        }

        return (<div className={'grid grid-nogutter'}>
            <div
                className={'col'}>{t('comments') + (kommentare && kommentare.length > 0 ? ` (${kommentare.length})` : '')}</div>
            <div className={'col-auto text-right'}>{right}</div>
        </div>);
    };

    const prepareDropdownData = (compareValue: any, altData: any[], listIndex: string | number) => {
        let listDropdown: any[] = [];
        if (props.data && compareValue) {
            altData.forEach((kElem: any) => {
                if (kElem[listIndex] === compareValue) {
                    listDropdown.push({...kElem});
                }

            });
        } else {
            listDropdown = [...altData];
        }
        const sortedData = listDropdown.sort((a, b) => a.name.localeCompare(b.name));
        return sortedData;
    };


    useEffect(() => {
        if (kreisQuery !== undefined) {
            const listKreis: any[] = prepareDropdownData(getValues('b_land_iso'), kreisQuery, 'b_land');
            setRevisedKreisList(listKreis);
        }
    }, [kreisQuery, getValues('b_land_iso')]);

    useEffect(() => {
        if (gemeindeQuery !== undefined) {
            const listKreis: any[] = prepareDropdownData(getValues('kreis'), gemeindeQuery, 'kreis_id');
            setRevisedGemeindeList(listKreis);
        }
    }, [gemeindeQuery, getValues('kreis')]);

    // <--- Accordion Headlines

    return (<div className={'relative h-full'}>
            <form ref={divRef} id="editParcelForm" onSubmit={handleSubmit(saveData)} className={'h-full'}>
                <FormPrompt hasUnsavedChanges={isDirty || mappingChanged}/>
                <EditDialogLayout left={<>
                    <div className={'grid'}>
                        <div className={'col-12 md:col-6 grid grid-nogutter'}>
                            <div className={'col-4'}>
                                {getStatus()}
                            </div>
                            <div className={'col-8 m-auto'}>
                                <Input edit={false} type={'checkbox'} name={'gebucht'}
                                       label={t('globalData:parcels.gebucht')} noMargin={true}
                                       validationControl={control} validationErrorMessage={getFormErrorMessage}
                                       validationRules={{
                                           required: false,
                                       }}/>

                                <div className={'p-1'}>
                                    <RadioButton className={'mr-2'}
                                                 inputId={'verpachtet_true'}
                                                 value={true} name="verpachtet"
                                                 checked={verpachtet}
                                                 disabled={true}/>
                                    <label
                                        htmlFor="verpachtet_true">{t('globalData:parcels.verpachtet')}</label>
                                </div>
                                <div className={'p-1'}>
                                    <RadioButton className={'mr-2'}
                                                 inputId={'verpachtet_false'}
                                                 value={false}
                                                 name="verpachtet"
                                                 checked={!verpachtet}
                                                 disabled={true}/>
                                    <label
                                        htmlFor="verpachtet_false">{t('globalData:parcels.unverpachtet')}</label>
                                </div>
                                {/* <Input edit={false} type={'checkbox'} name={'vertrag'}*/}
                                {/*       label={t('globalData:parcels.vertrag')} noMargin={true}*/}
                                {/*       validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                                {/*       validationRules={{*/}
                                {/*           required: false,*/}
                                {/*       }}/>*/}
                            </div>
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editParcels)}
                                label={t('globalData:parcels.flstkennz')} name={'flstkennz'}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: t('globalData:parcels.flstkennz') + ' ' + t('input:required')
                                }}
                                onChange={onChangeFlstKennz}
                            />
                        </div>
                    </div>
                    {/* <br/>*/}
                    {/* <Accordion activeIndex={0}>*/}
                    {/*    <AccordionTab header={t('globalData:parcels.parcelInformations')}>*/}
                    <div className={'grid'}>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editParcels)}
                                label={t('globalData:parcels.countryIso')} name={'land_name'}
                                value={props.data ? props.data.land_name : undefined}
                                type={'dropdown'}
                                dropdownOptions={countryIsoList}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: false,
                                }}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}><Input
                            edit={checkPermission(permissions.editParcels)} label={t('globalData:parcels.stateIso')}
                            name={'b_land_iso'}
                            onChange={onChangeFlur}
                            type={'dropdown'}
                            dropdownOptions={bundeslandQuery.map((item: any) => {
                                return {
                                    value: item.id, label: <div className={'flex'}><img className={'mr-1'}
                                                                                        src={`/images/wappen/${item.id}.svg`}
                                                                                        width={25}
                                                                                        height={25}/>
                                        <div className={'my-auto'}>{item.name}</div>
                                    </div>,
                                };
                            })}
                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false,
                            }}
                        />
                        </div>
                    </div>
                    <hr/>
                    <div className={'grid'}>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editParcels)}
                                label={t('globalData:parcels.kreis_name')}
                                name={'kreis'}
                                onChange={onChangeKreis}
                                type={'dropdown'}
                                dropdownOptions={revisedKreisList.map((item: any) => {
                                    return {
                                        value: item.id, label: <div className={'flex'}>
                                            <div className={'my-auto'}>{item.name}</div>
                                        </div>,
                                    };
                                })}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: false,
                                }}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editParcels)}
                                label={t('globalData:parcels.gemeinde_name')}
                                name={'gemeinde'}
                                onChange={onChangeGemeinde}
                                type={'dropdown'}
                                dropdownOptions={revisedGemeindeList.map((item: any) => {
                                    return {
                                        value: item.id, label: <div className={'flex'}>
                                            <div className={'my-auto'}>{item.name}</div>
                                        </div>,
                                    };
                                })}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: false,
                                }}
                            />
                        </div>
                        <div className={'col-12 md:col-6'}><Input
                            edit={checkPermission(permissions.editParcels)} label={t('globalData:parcels.gemarkung')}
                            name={'gemarkung'}
                            type={'dropdown'}
                            dropdownOptions={gemarkungCodes}
                            dropdownEditable={true}
                            maxLength={6}
                            onChange={onChangeFlur}
                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false,
                            }}
                        /></div>
                        <div className={'col-12 md:col-6'}><Input
                            edit={checkPermission(permissions.editParcels)} label={t('globalData:parcels.flur')}
                            name={'flur'}
                            onChange={onChangeFlur}
                            maxLength={3}
                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false,
                            }}
                        /></div>
                        <div className={'col-12 md:col-2'}><Input
                            edit={checkPermission(permissions.editParcels)} label={t('globalData:parcels.flstzaehler')}
                            name={'flstzaehler'}
                            maxLength={5}
                            onChange={onChangeFlur}
                            validationControl={control} validationErrorMessage={getFormErrorMessage}
                            validationRules={{
                                required: false,
                            }}
                        /></div>
                        <div className={'col-12 md:col-2'}>
                            <Input
                                edit={checkPermission(permissions.editParcels)}
                                label={t('globalData:parcels.flstnenner')}
                                name={'flstnenner'}
                                maxLength={4}
                                onChange={onChangeFlur}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: false,
                                }}
                            /></div>
                        <div className={'col-12 md:col-2'}>
                            <Input
                                edit={checkPermission(permissions.editParcels)}
                                label={t('globalData:parcels.flstfolge')}
                                disabled={disableFolge}
                                name={'flstfolge'}
                                maxLength={2}
                                onChange={onChangeFlur}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: false,
                                }}
                            /></div>
                        <div className={'col-12 md:col-6'}>
                            <Input
                                edit={checkPermission(permissions.editParcels)}
                                label={t('globalData:parcels.katasterGroesse')}
                                name={'kataster_groesse'}
                                validationControl={control} validationErrorMessage={getFormErrorMessage}
                                validationRules={{
                                    required: false,
                                }}
                            /></div>
                    </div>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('globalData:parcels.flaechenabweichungen')}>
                            <div className={'grid'}>
                                <div className={'col-12 md:col-6'}>
                                    <Input
                                        edit={false} label={t('globalData:parcels.abweichung_grundbuch')}
                                        name={'abweichung_grundbuch'}
                                        type={'number'}
                                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                                        validationRules={{
                                            required: false,
                                        }}
                                    />
                                </div>
                                <div className={'col-12 md:col-6'}>
                                    <Input
                                        edit={false} label={t('globalData:parcels.abweichung_plan')}
                                        name={'abweichung_plan'}
                                        type={'number'}
                                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                                        validationRules={{
                                            required: false,
                                        }}
                                    />
                                </div>
                                <div className={'col-12 md:col-6'}>
                                    <Input
                                        edit={false} label={t('globalData:parcels.abweichung_geo')}
                                        name={'abweichung_geo'}
                                        type={'number'}
                                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                                        validationRules={{
                                            required: false,
                                        }}
                                    />
                                </div>
                            </div>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('globalData:parcels.schutzbestaende')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={getLiegenschaftInfoAccordionHeadline()}>
                            <div className={'grid'}>
                                <div className={'col-12 md:col-6'}>
                                    <Input
                                        edit={checkPermission(permissions.editParcels)}
                                        label={t('globalData:parcels.liegenschaft_name')}
                                        name={'liegenschaft_name'}
                                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                                        validationRules={{
                                            required: false,
                                        }}
                                    />
                                </div>
                                <div className={'col-12 md:col-6'}>
                                    <Input
                                        edit={checkPermission(permissions.editParcels)}
                                        label={t('globalData:parcels.nutzungType')}
                                        name={'liegenschaft_nutzung_types'}
                                        type={'multiselect'}
                                        dropdownOptions={parcelUseTypesQuery.map((item: any) => {
                                            return {value: item.id, label: item.name};
                                        })}
                                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                                        validationRules={{
                                            required: false,
                                        }}
                                    />
                                </div>
                                {/* <div className={'col-12 md:col-6'}>*/}
                                {/*    <Input*/}
                                {/*        className={'w-full'}*/}
                                {/*        edit={checkPermission(permissions.editParcels)} label={t('globalData:parcels.lfdnrbestandsvz')}*/}
                                {/*        name={'lfdnrbestandsvz'}*/}
                                {/*        validationControl={control} validationErrorMessage={getFormErrorMessage}*/}
                                {/*        validationRules={{*/}
                                {/*            required: false,*/}
                                {/*            // required: t('globalData:parcels.lfdnrbestandsvz') + ' ' + t('input:required'),*/}
                                {/*        }}*/}
                                {/*    />*/}
                                {/* </div>*/}
                            </div>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={getGrundstueckAccordionHeadline()}>
                            <PropertyValueForm projectId={props.projectId} t={t}
                                               getFormErrorMessage={getFormErrorMessage}
                                               form={{
                                                   control,
                                                   formState: {errors},
                                                   handleSubmit,
                                                   setValue,
                                                   getValues,
                                                   watch
                                               }} edit={checkPermission(permissions.editParcels)}/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={getKatasterAccordionHeadline()}>
                            <div className={'grid'}>

                                <div className={'col-12 md:col-6'}>
                                    <Input
                                        edit={checkPermission(permissions.editParcels)}
                                        label={t('globalData:parcels.katasterfortschreibung_type')}
                                        name={'katasterfortschreibung_type'}
                                        type={'dropdown'}
                                        dropdownOptions={katasterFortschreibungTypesQuery.data && katasterFortschreibungTypesQuery.data.map((item: any) => {
                                            return {value: item.id, label: item.name};
                                        })}
                                        validationControl={control} validationErrorMessage={getFormErrorMessage}
                                        validationRules={{
                                            required: false,
                                        }}
                                    />
                                </div>
                                <div className={'col-12 md:col-6'}>
                                    <div className={'relative w-full h-full flex'}>
                                        <Button
                                            className={'p-button-success p-button-outlined p-button-icon-only absolute'}
                                            style={{left: '0', bottom: '0'}}
                                            disabled={true}
                                            type={'button'} icon={'pi pi-plus'} onClick={() => {
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab
                            header={getCommentAccordionHeadline()}>
                            <CommentForm projectId={props.projectId} t={t} type={'flurstueck'}
                                         getFormErrorMessage={getFormErrorMessage}
                                         form={{
                                             control,
                                             formState: {errors},
                                             handleSubmit,
                                             setValue,
                                             getValues,
                                             watch
                                         }} edit={checkPermission(permissions.editParcels)}
                                         kommentare={kommentare}/>
                        </AccordionTab>
                    </Accordion>
                    <br/>
                    <Accordion>
                        <AccordionTab header={t('documents')}>
                            <UnderConstruction/>
                        </AccordionTab>
                    </Accordion>
                </>}
                                  right={<TabView activeIndex={0} className={'h-full'} renderActiveOnly={false}>
                                      <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                              icon={faMapLocation}/>{t('tabs.geoMap')}
                                      </div>}>
                                          <MapOl key={'parcelpreview_maps'} zoom={zoom} center={center}
                                                 divHeight={'75vH'}
                                                 toolkitEnabled={false}
                                                 position={'relative'}
                                                 propElem={/* {project: {id:props.projectId, base_layer:'osmger'}}*/{project: props.geoData}}>
                                              <LayersMapOl key={props.projectId + '_layerMapsParcel'}>
                                                  <BaseLayers projectId={props.projectId}
                                                              mapDataWorkBench={props.geoData.baselayer_workspace}
                                                              baseLayer={props.geoData.baseLayer ? props.geoData.baseLayer : 'gm_layer_maps'}/>
                                                  <SingleLayer layerName={geoSettings.parcelLayer}
                                                               workspace={'rightguard'} styleName={null}
                                                               layerKind={'vectorData'}
                                                               featureKennz={[props.data?.flstkennz]}/>
                                              </LayersMapOl>
                                          </MapOl>
                                      </TabPanel>
                                      <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                              icon={faDatabase}/>{t('tabs.relationshipProjectMasterData')}
                                      </div>}>
                                          <br/>
                                          {checkPermission(permissions.seeMeasures) && <><Accordion activeIndex={0}>
                                              <AccordionTab header={t('projectMasterData:measures.plural')}>
                                                  <MeasureOverview
                                                      projectId={props.projectId}
                                                      mapping={props.data ? {flurstueck_id: props.data.flurstueck_id} : {}}
                                                      editable={false}
                                                      expandable={false}
                                                      hideGlobalFilter={false}
                                                      showColumnFilters={true}
                                                      hideButtons={true}
                                                      skeletonCount={1}
                                                      showHeader={false}
                                                  />
                                              </AccordionTab>
                                          </Accordion>
                                              <br/></>}
                                          {checkPermission(permissions.seeUtilisation) && <><Accordion activeIndex={0}>
                                              <AccordionTab header={t('projectMasterData:utilisation.plural')}>
                                                  <UtilisationOverview
                                                      projectId={props.projectId}
                                                      mapping={props.data ? {flurstueck_id: props.data.flurstueck_id} : {}}
                                                      editable={false}
                                                      expandable={false}
                                                      hideGlobalFilter={false}
                                                      showColumnFilters={true}
                                                      hideButtons={true}
                                                      skeletonCount={1}
                                                      showHeader={false}
                                                  />
                                              </AccordionTab>
                                          </Accordion></>}
                                      </TabPanel>
                                      <TabPanel header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                              icon={faProjectDiagram}/>{t('tabs.relationshipProjectProcessing')}
                                      </div>}>
                                          <br/>
                                          {checkPermission(permissions.seeProcess) && <><Accordion activeIndex={0}>
                                              <AccordionTab header={t('globalData:process.plural')}>
                                                  <ProcessOverview
                                                      showParcels={true}
                                                      showPersons={false}
                                                      showLandRegisters={false}
                                                      mapping={props.data ? {flurstueck_id: props.data.flurstueck_id} : {}}
                                                      projectId={props.projectId}
                                                      editable={false}
                                                      expandable={false}
                                                      hideGlobalFilter={false}
                                                      showColumnFilters={true}
                                                      skeletonCount={1}
                                                      geoData={props.geoData}
                                                      showHeader={false}
                                                  />
                                              </AccordionTab>
                                          </Accordion>
                                              <br/></>}
                                          {checkPermission(permissions.seePersons) && <><Accordion activeIndex={0}>
                                              <AccordionTab header={t('globalData:global.personen')}>
                                                  <PersonMapping projectId={props.projectId}
                                                                 mappingId={props.data ? props.data.flurstueck_id : ''}
                                                                 mappingType={MappingType.personParcel}
                                                      // dataIds={props.data && props.data.person ? props.data.person : []}
                                                      // scrollHeight={`${height / 2 - 150}px`}
                                                                 showHeader={false} skip={!props.data}
                                                                 onChange={() => {
                                                                     setMappingChanged(true);
                                                                 }}
                                                                 isDirty={isDirty || mappingChanged}/>
                                              </AccordionTab>
                                          </Accordion>
                                              <br/></>}
                                          {checkPermission(permissions.seeLandregister) && <><Accordion activeIndex={0}>
                                              <AccordionTab header={t('globalData:global.landRegisters')}>
                                                  <LandRegisterMapping projectId={props.projectId}
                                                                       mappingId={props.data ? props.data.flurstueck_id : ''}
                                                                       mappingType={MappingType.landRegisterParcel}
                                                      // dataIds={props.data && props.data.grundbuch ? props.data.grundbuch : []}
                                                      // scrollHeight={`${height / 2 - 150}px`}
                                                                       skip={!props.data}
                                                                       onChange={() => {
                                                                           setMappingChanged(true);
                                                                       }}
                                                                       isDirty={isDirty || mappingChanged}/>
                                                  <br/>
                                              </AccordionTab>
                                          </Accordion>
                                              <br/></>}
                                          <Accordion>
                                              <AccordionTab disabled={true} header={t('globalData:global.ecoAccounts')}>
                                                  <UnderConstruction/>
                                              </AccordionTab>
                                          </Accordion>
                                          <br/>
                                          <Accordion>
                                              <AccordionTab disabled={true} header={t('globalData:global.research')}>
                                                  <UnderConstruction/>
                                              </AccordionTab>
                                          </Accordion>
                                          <br/>
                                          <Accordion>
                                              <AccordionTab disabled={true} header={t('correspondence:plural')}>
                                                  <UnderConstruction/>
                                              </AccordionTab>
                                          </Accordion>
                                          <br/>
                                          {props.data && checkPermission(permissions.seeContracts) && <><Accordion>
                                              <AccordionTab header={t('contract:pluralShort')}>
                                                  <ContractMapping projectId={props.projectId}
                                                                   mappingId={props.data.flurstueck_id}
                                                                   mappingType={MappingType.parcelContract}
                                                                   onChange={() => {
                                                                       setMappingChanged(true);
                                                                   }}/>
                                              </AccordionTab>
                                          </Accordion>
                                              <br/></>}
                                          <Accordion>
                                              <AccordionTab disabled={true}
                                                            header={t('globalData:global.legalProceedings')}>
                                                  <UnderConstruction/>
                                              </AccordionTab>
                                          </Accordion>
                                          <br/>
                                          <Accordion>
                                              <AccordionTab disabled={true} header={t('payment:plural')}>
                                                  <UnderConstruction/>
                                              </AccordionTab>
                                          </Accordion>
                                          <br/>
                                          <Accordion>
                                              <AccordionTab disabled={true} header={t('invoice:plural')}>
                                                  <UnderConstruction/>
                                              </AccordionTab>
                                          </Accordion>
                                          <br/>
                                      </TabPanel>
                                      <TabPanel disabled={true}
                                                header={<div><FontAwesomeIcon className="sidebar-icon mr-2"
                                                                              icon={faList}/>{t('tabs.relationshipProjectManagement')}
                                                </div>}></TabPanel>
                                  </TabView>}/>
            </form>
            {showNewProcess && <CustomDialog
                onClick={() => {
                    let createOrUpdate = props.data ? updateParcel : createParcel;

                    isCleaned.mappings = getMappingsForUpdate('flurstueck_id', props.data ? props.data.flurstueck_id : '', mappings);
                    isCleaned.neuer_vorgang = newProcess;
                    createOrUpdate(isCleaned).then(async (result: any) => {
                        if (!result.error) {
                            setNewProcess(false);
                            showMessageOnSuccess(t('globalData:global.parcelUpdated'), '');
                            props.onFinished(isCleaned);
                            moveComments(getValues, setValue);
                            reset(undefined, {keepValues: true});
                            setMappingChanged(false);
                        }
                        setShowNewProcess(false);
                    });
                }}
                onCancel={() => {
                    showMessageOnError(t('globalData:dialogs.newProcessCanceled'), t('globalData:dialogs.newProcessParcelNotSaved'));
                    setShowNewProcess(false);
                    setNewProcess(false);
                }} visible={showNewProcess} header={t('globalData:dialogs.newProcessDialog')}>
                <div>
                    <p>{t('globalData:dialogs.newProcessDialogMessage')}</p>
                    <div className={'col pl-2'}>
                        <div className={'p-1'}>
                            <RadioButton className={'mr-2'}
                                         inputId={'new_process_false'}
                                         value={false} name="new_process"
                                         onChange={() => {
                                             setNewProcess(false);
                                         }}
                                         checked={!newProcess}/>
                            <label
                                htmlFor="new_process_false">{t('globalData:dialogs.newProcessDialogMessage1')}</label>
                        </div>
                        <div className={'p-1'}>
                            <RadioButton className={'mr-2'}
                                         inputId={'new_process_true'}
                                         value={true}
                                         name="new_process"
                                         onChange={() => {
                                             setNewProcess(true);
                                         }}
                                         checked={newProcess}/>
                            <label
                                htmlFor="new_process_true">{t('globalData:dialogs.newProcessDialogMessage2')}</label>
                        </div>
                    </div>
                </div>
            </CustomDialog>}
        </div>
    );
};
